import { render, staticRenderFns } from "./Marketingphoto.vue?vue&type=template&id=a0774162&scoped=true&"
import script from "./Marketingphoto.vue?vue&type=script&lang=js&"
export * from "./Marketingphoto.vue?vue&type=script&lang=js&"
import style0 from "./Marketingphoto.vue?vue&type=style&index=0&id=a0774162&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0774162",
  null
  
)

export default component.exports